export const baseNotificationProps = {
  radius: 2,
  autoClose: 8000,
  withCloseButton: true,
};
